(function () {
  if (window.__discoverTopicNavigationLoaded) {
    return;
  }

  window.__discoverTopicNavigationLoaded = true;

  function initSection(section) {
    if (!section || section.dataset.discoverNavigationInitialized === 'true') {
      return;
    }

    var links = Array.prototype.slice.call(
      section.querySelectorAll('[data-discover-topic-nav] a[href^="#discover-"]')
    );

    if (!links.length) {
      return;
    }

    section.dataset.discoverNavigationInitialized = 'true';

    var targetIds = [];
    var targets = links
      .map(function (link) {
        return link.getAttribute('href').slice(1);
      })
      .filter(function (id) {
        if (targetIds.indexOf(id) !== -1) {
          return false;
        }

        targetIds.push(id);
        return true;
      })
      .map(function (id) {
        return document.getElementById(id);
      })
      .filter(Boolean);

    var updateQueued = false;

    function setActive(id) {
      links.forEach(function (link) {
        var isActive = link.getAttribute('href') === '#' + id;
        link.classList.toggle('is-active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    function updateActiveFromPosition() {
      updateQueued = false;

      if (!targets.length) {
        return;
      }

      var activationLine = Math.max(110, window.innerHeight * 0.32);
      var currentTarget = targets[0];

      targets.forEach(function (target) {
        if (target.getBoundingClientRect().top <= activationLine) {
          currentTarget = target;
        }
      });

      setActive(currentTarget.id);
    }

    function requestUpdate() {
      if (updateQueued) {
        return;
      }

      updateQueued = true;
      window.requestAnimationFrame(updateActiveFromPosition);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    updateActiveFromPosition();
  }

  function initAll(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('[data-discover-navigation-section]')) {
      initSection(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll('[data-discover-navigation-section]').forEach(initSection);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest('[data-discover-topic-nav] a[href^="#discover-"]');

      if (!link) {
        return;
      }

      var target = document.getElementById(link.getAttribute('href').slice(1));

      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    },
    true
  );

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  initAll(document);
})();
